"use client";
import { gql } from "@apollo/client";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogin, setUserData, updateData } from "../redux/slice/userData";
import { client } from "../utils/apollo";

const GET_USER = gql`
  query User {
    user {
      surname
      name
      id_user
      email
    }
  }
`;

const useUser = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.userData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = (isLogin: boolean) => {
    dispatch(setIsLogin({ isLogin }));
  };
  const setUserLoginData = (
    id_user: number,
    name: string,
    email: string,
    surname: string
  ) => {
    dispatch(setUserData({ id_user, name, email, surname }));
  };
  const handlerUpdate = (data: Partial<IUserData>) => {
    dispatch(updateData(data));
  };

  const FetchUser = async () => {
    setLoading(true);
    setError("");
    try {
      const token = Cookies.get(process.env.NEXT_PUBLIC_TOKEN_NAME as string);
      if (!token) {
        setLoading(false);
        return;
      }
      const { data } = await client.query({
        query: GET_USER,
        context: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      });
      if (data) {
        Cookies.set("userId", data.user.id_user);
        setUserLoginData(
          data.user.id_user,
          data.user.name,
          data.user.email,
          data.user.surname
        );
        login(true);
      }
    } catch (error: any) {
      setError("Su sesión ha caducado o hubo un error de autenticación");
      Cookies.remove("userId");
      setUserLoginData(0, "", "", "");
      login(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      FetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    userData,
    login,
    setUserLoginData,
    handlerUpdate,
    loading,
    error,
  };
};

export default useUser;
